import { inRange, isUndefined, min, round } from 'lodash';

export const toRange =
  (minValue: number, maxValue: number) =>
  (value: number): number =>
    inRange(value, minValue, maxValue)
      ? value
      : value < minValue
      ? minValue
      : (min([value, maxValue]) as number);

export const applyIfNotEmpty =
  (fn: (value: any) => any) =>
  (value: string): any =>
    value ? fn(value) : value;

export const bytesToMegabytes = (bytes: number) => {
  return round(bytes / 1024 / 1024, 2);
};

export const toCapitalize = (word: string) => {
  const [start, ...rest] = word.toLowerCase().split('');
  return [start.toUpperCase(), ...rest].join('');
};

export const fileToBase64 = async (file: File): Promise<string | undefined> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const removeUndefinedKeys = (value: Record<string, any>) => {
  return Object.entries(value).reduce<Record<string, any>>(
    (result, [key, value]) => {
      if (!isUndefined(value)) {
        result[key] = value;
      }
      return result;
    },
    {},
  );
};
